var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.752 0.278931C16.8448 0.278931 16.9373 0.279891 17.0296 0.281801L17.1274 0.28248C24.372 0.485714 30.1864 6.54936 30.1864 14C30.1864 21.578 24.1716 27.7211 16.752 27.7211C9.33243 27.7211 3.31766 21.578 3.31766 14C3.31766 10.7237 4.44199 7.71554 6.31808 5.35614C2.42027 4.15007 -2.31182 0.28248 1.27106 0.28248L16.4623 0.282058C16.5586 0.279977 16.6552 0.278931 16.752 0.278931ZM16.752 6.09295C12.4763 6.09295 9.01019 9.63306 9.01019 14C9.01019 18.367 12.4763 21.9071 16.752 21.9071C21.0277 21.9071 24.4939 18.367 24.4939 14C24.4939 9.63306 21.0277 6.09295 16.752 6.09295Z",
    fill: "#02862F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.89bef0c1b2adb49019e9d9da69005f32.svg";
export { ForwardRef as ReactComponent };